/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faCalendarAlt,
  faMoneyBill,
  faFileExcel,
} from '@fortawesome/free-solid-svg-icons';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import moment from 'moment';
import Search from '../../components/Search';
import LoadingModal from '../../components/LoadingModal';
import logoImg from '../../assets/images/logo.png';
import {
  getAllUpcomingLoanRequest,
  getAllApprovedAndRejectedStatus,
  getAllCountForFarmerLoan,
  exportExcelForPending,
  exportExcelForCompleted,
} from '../../store/modules/farmerLoan/actions';
import {
  selectPlantPastHeldOrders, selectPlantUpcomingOrders, selectIsLoading, selectCount, selectIsLoadingCount,
} from '../../store/modules/farmerLoan/selectors';

import './FarmerLoan.scss';

const FarmerLoan = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(null);
  const dispatch = useDispatch();
  const upcoming = useSelector((state) => selectPlantUpcomingOrders(state));
  const count = useSelector((state) => selectCount(state));
  const pastHeld = useSelector((state) => selectPlantPastHeldOrders(state));
  const isLoading = useSelector((state) => selectIsLoading(state));
  const isLoadingCount = useSelector((state) => selectIsLoadingCount(state));
  const role = localStorage.getItem('role');
  useEffect(() => {
    if (tabIndex === 1) {
      dispatch(getAllApprovedAndRejectedStatus());
    } else {
      dispatch(getAllUpcomingLoanRequest());
    }
  }, [tabIndex]);

  useEffect(() => {
    dispatch(getAllCountForFarmerLoan());
  }, [dispatch]);

  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };

  const nextUpcomingPage = (page) => {
    dispatch(getAllUpcomingLoanRequest(page));
  };

  const previousUpcomingPage = (page) => {
    dispatch(getAllUpcomingLoanRequest(page));
  };

  const nextPastHeldPage = (page) => {
    dispatch(getAllUpcomingLoanRequest(page));
  };

  const previousPastHeldPage = (page) => {
    dispatch(getAllUpcomingLoanRequest(page));
  };

  const handleOnExportRecordsExcel = async () => {
    if (tabIndex === 1) {
      dispatch(exportExcelForCompleted()).finally(() => {
      });
    } else {
      dispatch(exportExcelForPending()).finally(() => {
      });
    }
  };

  return (
    <>
      <div className="admin-orders">
        <div className="row middle">
          <div className="col-12 col-md-3">
            <div className="summary-card warning mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Pending Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.pendingLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card green mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Finished Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.finsihedLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card danger mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Rejected Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.rejectedLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card primary mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Total Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.totalLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="heading">
              <p className="heading__title">
                Finlease Loan Details
              </p>
            </div>
            {role === 'finlease' && (
            <div className="buttons">
              <button
                type="button"
                className="button green"
                onClick={() => handleOnExportRecordsExcel()}
              >
                <>
                  <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                  Export
                </>
              </button>
            </div>
            )}
          </div>
          {/* <div className="col-12 col-md-6"></div> */}
        </div>
        <Tabs
          defaultIndex={0}
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <TabList className="row between tab-list">
            <Tab className="col-6 tab">
              <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
                Waiting for Approval
              </div>
            </Tab>
            <Tab className="col-6 tab">
              <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
                Completed
              </div>
            </Tab>
          </TabList>
          <TabPanel className="appointments-tab-panel">
            {/* <div className="row middle">
              <div className="col-12 col-md-12">
                <Search value={query} onChangeText={handleChange} onSubmit={search} />
              </div>
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button type="button" className="button green">
                    <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                    Export
                  </button>
                </div>
              </div>
            </div> */}
            <div className="row">
              {upcoming && upcoming.paginate && upcoming.paginate.length
                ? upcoming.paginate.map((item) => (
                  <div className="col-12 col-lg-12">
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          <img src={item?.Farmer?.profilePicture} alt="order" />
                        </div>
                        <div className="card__text">
                          <div>
                            <span className="card__title">
                              Farmer Name :
                              {' '}
                            </span>
                            {item?.Farmer ? item?.Farmer?.farmerName : ''}
                          </div>
                          <div>
                            <span className="card__title">
                              Plant Code :
                              {' '}
                            </span>
                            {/* {item?.id ? item?.id : ''} */}
                            {item?.Farmer ? item?.Farmer?.plateCode : ''}

                          </div>
                          <div>
                            <span className="card__title">
                              Loan Request Date :
                              {' '}
                            </span>
                            {moment(item?.createdAt).format('DD/MM/YYYY')}
                          </div>
                          <div>
                            <span className="card__title">
                              Loan Request Time :
                              {' '}
                            </span>
                            {moment(item?.createdAt).format('hh:mm a')}
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        <Link to={`/admin/farmerLoan/${item?.id}`} className="card__button">View</Link>
                      </div>
                    </div>
                  </div>
                ))
                : (
                  null
                )}
              {!isLoading && !upcoming && (
              <div className="col-12 col-lg-12 d-flex-col middle">
                <div className="notFound">
                  <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                  <span className="notFound__text">No upcoming Loan Request found</span>
                </div>
              </div>
              )}
            </div>
            {upcoming
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Previous}
                        onClick={() => previousUpcomingPage(upcoming.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {upcoming.Next
                          ? upcoming.Next.page - 1
                          : upcoming.Previous
                            ? upcoming.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Next}
                        onClick={() => nextUpcomingPage(upcoming.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
          <TabPanel className="appointments-tab-panel">
            {/* <div className="row middle">
              <div className="col-12 col-md-12">
                <Search value={query} onChangeText={handleChange} onSubmit={search} />
              </div>
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button type="button" className="button green">
                    <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                    Export
                  </button>
                </div>
              </div>
            </div> */}
            <div className="row">
              {pastHeld && pastHeld.paginate && pastHeld.paginate.length
                ? pastHeld.paginate.map((item) => (
                  <div className="col-12 col-lg-12">
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          <img src={item?.Farmer?.profilePicture} alt="order" />
                        </div>
                        <div className="card__text">
                          <div className="row start">
                            <div className="col-12 col-lg-4">
                              <div>
                                <span className="card__title">
                                  Farmer Name :
                                  {' '}
                                </span>
                                {item?.Farmer ? item?.Farmer?.farmerName : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Plant Code :
                                  {' '}
                                </span>
                                {item?.Farmer ? item?.Farmer?.plateCode : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Loan Request Date :
                                  {' '}
                                </span>
                                {moment(item.createdAt).format('DD/MM/YYYY')}
                              </div>
                              <div>
                                <span className="card__title">
                                  Loan Request Time :
                                  {' '}
                                </span>
                                {moment(item?.createdAt).format('hh:mm a')}
                              </div>
                            </div>
                            <div className="col-12 col-lg-4">
                              <div>
                                <span className="card__title">
                                  {item?.requestStatus === 'Approved' ? 'Approved Date' : 'Rejected Date'}
                                  {' '}
                                  :
                                  {' '}
                                </span>
                                {moment(item?.updatedAt).format('DD/MM/YYYY')}
                              </div>
                              <div>
                                <span className="card__title">
                                  {item.requestStatus === 'Approved' ? 'Approved Time' : 'Rejected Time'}
                                  {' '}
                                  :
                                  {' '}
                                </span>
                                {moment(item?.updatedAt).format('hh:mm a')}
                              </div>
                              <div>
                                <span className="card__title">
                                  Total Time Taken :
                                  {' '}
                                </span>
                                {moment(item?.updatedAt).diff(item?.createdAt, 'days')}
                                {' '}
                                days
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        <div
                          className={`card__text--${item?.requestStatus === 'Approved' ? 'success'
                            : item?.requestStatus === 'Rejected' ? 'danger' : ''}`}
                        >
                          <span
                            className="card__title"
                          >
                            Status :
                            {' '}
                          </span>
                          {item?.requestStatus === 'Approved' ? 'Approved' : item?.requestStatus}
                        </div>
                        <Link
                          to={`/admin/farmerLoan/${item.id}`}
                          className="card__button"
                        >
                          View
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
                : (
                  null
                )}
              {!isLoading && !pastHeld && (
              <div className="col-12 col-lg-12 d-flex-col middle">
                <div className="notFound">
                  <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                  <span className="notFound__text">No past held Loans found</span>
                </div>
              </div>
              )}
            </div>
            {pastHeld
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Previous}
                        onClick={() => previousPastHeldPage(pastHeld.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {pastHeld.Next
                          ? pastHeld.Next.page - 1
                          : pastHeld.Previous
                            ? pastHeld.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Next}
                        onClick={() => nextPastHeldPage(pastHeld.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
        </Tabs>
      </div>
      <LoadingModal show={isLoading || isLoadingCount} />
    </>
  );
};

export default FarmerLoan;
